import * as Yup from "yup";

export const subscriptionSchema = Yup.object().shape({
  client_id: Yup.mixed<number | string>()
    .required("Cliente é obrigatório")
    .test(
      "not-empty",
      "Cliente é obrigatório",
      (value) => value !== "" && value !== undefined && value !== null,
    ),

  subscription_id: Yup.mixed<number | string>()
    .required("Assinatura é obrigatória")
    .test(
      "not-empty",
      "Assinatura é obrigatória",
      (value) => value !== "" && value !== undefined && value !== null,
    ),

  expiration_date: Yup.mixed<Date | string>().nullable(),
});
